<div
    gaCategory="View Tutorial"
    class="pages"
    [ngClass]="{'pages--opaquer': tutorial.pageIndex == tutorial.pageSize - 1}"
    *ngIf="tutorial$ | async; let tutorial" >

    <!-- exit -->
    <button
        gaEvent
        gaAction="Clicked Exit Tutorial"
        app-pin-button
        buttonType="dark"
        size="medium"
        icon="times"
        aria-label="Exit Tutorial"
        matTooltip="Exit Tutorial"
        matTooltipPosition="right"
        class="pages__close"
        (click)="handleExitClick()">
    </button>

    <!-- pages -->
    <div class="pages__contents">
        <ng-content></ng-content>
    </div>

    <!-- navigation -->
    <div class="pages__footer" *ngIf="tutorial.pageIndex < tutorial.pageSize - 1">

        <button
            gaEvent
            gaAction="Clicked Previous Tutorial Step"
            app-pin-button
            buttonType="dark"
            size="large"
            icon="angle-left"
            aria-label="Previous Tutorial Step"
            matTooltip="Previous Tutorial Step"
            matTooltipPosition="left"
            class="pages__nav"
            [disabled]="tutorial.pageIndex < 1"
            [attr.aria-disabled]="tutorial.pageIndex < 1"
            [attr.tabindex]="tutorial.pageIndex < 1 ? -1 : 0"
            (click)="handlePrevClick()">
        </button>

        <div class="mh-8">
            {{ tutorial.pageIndex + 1 }} / {{ tutorial.pageSize }}
        </div>

        <button
            gaEvent
            gaAction="Clicked Next Tutorial Step"
            app-pin-button
            buttonType="dark"
            size="large"
            icon="angle-right"
            aria-label="Next Tutorial Step"
            matTooltip=" Next Tutorial Step"
            matTooltipPosition="right"
            class="pages__nav"
            [disabled]="tutorial.pageIndex === tutorial.pageSize -1"
            [attr.aria-disabled]="tutorial.pageIndex === tutorial.pageSize -1"
            [attr.tabindex]="tutorial.pageIndex === tutorial.pageSize -1 ? -1 : 0"
            (click)="handleNextClick()">
        </button>
        
    </div>
    
</div>